import React, { useState, useEffect, useContext } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { FaCalendarAlt, FaUserFriends, FaBuilding, FaArrowRight } from 'react-icons/fa';
import { useCart } from './CartContext';
import { AuthContext } from '../../context/AuthContext';

// Import specific images for all modules
import EnvImage from './General Safety/env2.jpeg';
import WarehouseImage from './Warehouse Safety/ware.jpg';
import MHEImage from './Warehouse Safety/mhe.jpg';
import CraneImage from './Warehouse Safety/crane.jpg';
import RoadImage from './Road Safety/safe.jpg';
import ISOImage from './ISO Training/iso.jpg';
import MentalImage from './Health Safety/well.jpg';
import AwarenessImage from './General Safety/worker3.jpg';
import SConceptImage from './General Safety/worker2.webp';
import LOTOImage from './General Safety/loto.jpg';
import PPEImage from './General Safety/ppe.jpg';
import BehaviorImage from './General Safety/behave.jpg';
import HeatImage from './Health Safety/heat.jpg';
import FirstAidImage from './Health Safety/aid.jpg';
import ErgImage from './Health Safety/erg.png';
import ElectricalImage from './Electrical/elect.jpg';
import FireImage from './Emegency Safety/fire.jpg';
import EmergImage from './Emegency Safety/emerg.jpg';
import ChemicalImage from './Chemical Safety/chem2.jpg';
import HeightImage from './Construction Safety/scaf.jpg';
import ConstImage from './Construction Safety/const.jpg';
import GeneralImage from './training_hero.png';
import ComplianceLinkImage from '../Compliance/compliance_hero.png';
import ConsultancyLinkImage from '../Consultancy/consultancy_hero.png';
import AuditLinkImage from '../Audit/audit_hero.png';

import './BookingPage.css';

// Comprehensive Course Data Map
const courses = {
    // --- General Safety ---
    'environmental': { id: 'env-001', name: 'Environmental Safety (ISO 14001)', duration: '2 Days', image: EnvImage },
    'awareness': { id: 'gen-001', name: 'General Safety Awareness', duration: '1 Day', image: AwarenessImage },
    '5s': { id: 'gen-002', name: '5S Methodology & Concepts', duration: '1 Day', image: SConceptImage },
    'loto': { id: 'gen-003', name: 'Lockout Tagout (LOTO)', duration: '1 Day', image: LOTOImage },
    'ppe': { id: 'gen-004', name: 'Personal Protective Equipment', duration: '1 Day', image: PPEImage },
    'behaviour': { id: 'gen-005', name: 'Behavioral Based Safety', duration: '1 Day', image: BehaviorImage },

    // --- Warehouse Safety ---
    'warehouse-safety': { id: 'wh-001', name: 'Warehouse Safety', duration: '2 Days', image: WarehouseImage },
    'mhe-safety': { id: 'wh-002', name: 'Material Handling Equipment (MHE)', duration: '2 Days', image: MHEImage },
    'crane-safety': { id: 'wh-003', name: 'Crane Safety Operations', duration: '2 Days', image: CraneImage },

    // --- Construction Safety ---
    'construction-safety': { id: 'const-001', name: 'Construction Safety', duration: '3 Days', image: ConstImage },
    'construction': { id: 'const-001', name: 'Construction Safety', duration: '3 Days', image: ConstImage }, // Alias for mismatch
    'height-safety': { id: 'const-002', name: 'Working at Height', duration: '2 Days', image: HeightImage },

    // --- Emergency Safety ---
    'fire-safety': { id: 'fire-001', name: 'Fire Safety & Prevention', duration: '1 Day', image: FireImage },
    'emergency-preparedness': { id: 'fire-002', name: 'Emergency Preparedness', duration: '1 Day', image: EmergImage },

    // --- Electrical Safety ---
    'electrical': { id: 'elec-001', name: 'Electrical Safety', duration: '2 Days', image: ElectricalImage },

    // --- Road Safety ---
    'road-safety': { id: 'road-001', name: 'Road Safety & Defensive Driving', duration: '1 Day', image: RoadImage },

    // --- Health Safety ---
    'mental-health': { id: 'health-001', name: 'Mental Health & Wellbeing', duration: '1 Day', image: MentalImage },
    'heat-stress': { id: 'health-002', name: 'Heat & Cold Stress Management', duration: '1 Day', image: HeatImage },
    'first-aid': { id: 'health-003', name: 'First Aid Training', duration: '2 Days', image: FirstAidImage },
    'ergonomics': { id: 'health-004', name: 'Ergonomics & Posture', duration: '1 Day', image: ErgImage },

    // --- Chemical Safety ---
    'chemical-safety': { id: 'chem-001', name: 'Chemical Safety Handling', duration: '2 Days', image: ChemicalImage },

    // --- ISO Training ---
    'iso-9001': { id: 'iso-001', name: 'ISO 9001:2015 QMS', duration: '3 Days', image: ISOImage },
    'iso-14001': { id: 'iso-002', name: 'ISO 14001:2015 EMS', duration: '3 Days', image: ISOImage },
    'iso-45001': { id: 'iso-003', name: 'ISO 45001:2018 OHSMS', duration: '3 Days', image: ISOImage },
    'iso-19011': { id: 'iso-004', name: 'ISO 19011:2018 Auditing', duration: '3 Days', image: ISOImage },
    'iso-documentation': { id: 'iso-005', name: 'ISO Documentation', duration: '2 Days', image: ISOImage },
    'hira': { id: 'iso-006', name: 'HIRA & Risk Assessment', duration: '2 Days', image: ISOImage },

    // --- Compliance ---
    'iso-14001-compliance': { id: 'comp-001', name: 'ISO 14001 Compliance Audit', duration: 'Consultation', image: ComplianceLinkImage },
    'iso-45001-compliance': { id: 'comp-002', name: 'ISO 45001 Compliance Audit', duration: 'Consultation', image: ComplianceLinkImage },
    'safety-legal-compliance': { id: 'comp-003', name: 'Safety Legal Compliance Audit', duration: 'Consultation', image: ComplianceLinkImage },

    // --- Consultancy ---
    'safety-legislation-consultancy': { id: 'cons-001', name: 'Safety Legislation Consultancy', duration: 'Consultation', image: ConsultancyLinkImage },
    'iso-9001-consultancy': { id: 'cons-002', name: 'ISO 9001 Consultancy', duration: 'Consultation', image: ConsultancyLinkImage },
    'iso-14001-consultancy': { id: 'cons-003', name: 'ISO 14001 Consultancy', duration: 'Consultation', image: ConsultancyLinkImage },
    'iso-45001-consultancy': { id: 'cons-004', name: 'ISO 45001 Consultancy', duration: 'Consultation', image: ConsultancyLinkImage },
    'risk-reduction-consultancy': { id: 'cons-005', name: 'Risk Reduction Strategy', duration: 'Consultation', image: ConsultancyLinkImage },
    'rca-consultancy': { id: 'cons-006', name: 'Root Cause Analysis (RCA)', duration: 'Consultation', image: ConsultancyLinkImage },

    // --- Audit ---
    'iso-9001-audit': { id: 'audit-001', name: 'ISO 9001 Audit', duration: 'Audit Service', image: AuditLinkImage },
    'iso-14001-audit': { id: 'audit-002', name: 'ISO 14001 Audit', duration: 'Audit Service', image: AuditLinkImage },
    'iso-45001-audit': { id: 'audit-003', name: 'ISO 45001 Audit', duration: 'Audit Service', image: AuditLinkImage },
    'ohsms-audit': { id: 'audit-004', name: 'OHSMS Audit', duration: 'Audit Service', image: AuditLinkImage },
    'safety-assessment': { id: 'audit-005', name: 'Safety Assessment Audit', duration: 'Audit Service', image: AuditLinkImage },

    // --- Default ---
    'default': {
        id: 'gen-000',
        name: 'General Safety Training',
        duration: '1 Day',
        image: GeneralImage
    }
};

const BookingPage = () => {
    const { courseId } = useParams();
    const navigate = useNavigate();
    const { addToCart } = useCart();
    const { isAuthenticated, user } = useContext(AuthContext);

    const [courseDetails, setCourseDetails] = useState(null);
    const [formData, setFormData] = useState({
        date: '',
        delegates: 1,
        companyName: '',
        specialRequirements: ''
    });

    useEffect(() => {
        // Debugging: Log the captured courseId from URL
        console.log("BookingPage Loaded. CourseID:", courseId);

        if (!isAuthenticated) {
            // Redirect to login if accessing directly without auth
            navigate('/login', { state: { from: `/booking/${courseId}` } });
            return;
        }

        // Case-insensitive lookup
        const key = courseId ? courseId.toLowerCase() : 'default';
        const details = courses[key] || courses['default'];

        console.log("Course Lookup Key:", key);
        console.log("Found Details:", details);

        setCourseDetails(details);

        // Pre-fill company if available in user profile
        if (user?.company) {
            setFormData(prev => ({ ...prev, companyName: user.company }));
        }
    }, [courseId, isAuthenticated, navigate, user]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        if (!courseDetails) return;

        const cartItem = {
            id: courseDetails.id + '-' + formData.date, // Unique ID based on course and date
            name: courseDetails.name,
            quantity: parseInt(formData.delegates),
            imageUrl: courseDetails.image || 'https://via.placeholder.com/150', // Use specific image
            bookingDetails: {
                date: formData.date,
                company: formData.companyName,
                delegates: formData.delegates,
                requirements: formData.specialRequirements
            }
        };

        addToCart(cartItem);
        navigate('/cart');
    };

    if (!courseDetails) return <div className="loading-state">Loading booking details...</div>;

    return (
        <div className="booking-page-container">
            <div className="booking-card">
                <div className="booking-header">
                    <h1>Secure Your Spot</h1>
                    <p className="subtitle">Complete your registration for {courseDetails.name}</p>
                </div>

                <div className="course-summary">
                    <div className="summary-item">
                        <span className="label">Service</span>
                        <span className="value">{courseDetails.name}</span>
                    </div>
                    <div className="summary-item">
                        <span className="label">Duration/Type</span>
                        <span className="value">{courseDetails.duration}</span>
                    </div>
                </div>

                <form onSubmit={handleSubmit} className="booking-form">
                    <div className="form-group">
                        <label><FaCalendarAlt /> Preferred Date</label>
                        <input
                            type="date"
                            name="date"
                            required
                            value={formData.date}
                            onChange={handleInputChange}
                            min={new Date().toISOString().split('T')[0]}
                        />
                    </div>

                    <div className="form-group">
                        <label><FaUserFriends /> Number of Delegates/Team Size</label>
                        <input
                            type="number"
                            name="delegates"
                            min="1"
                            max="50"
                            required
                            value={formData.delegates}
                            onChange={handleInputChange}
                        />
                    </div>

                    <div className="form-group">
                        <label><FaBuilding /> Company Name (Optional)</label>
                        <input
                            type="text"
                            name="companyName"
                            value={formData.companyName}
                            onChange={handleInputChange}
                            placeholder="e.g., Acme Corp"
                        />
                    </div>

                    <div className="form-group">
                        <label>Special Requirements</label>
                        <textarea
                            name="specialRequirements"
                            rows="3"
                            value={formData.specialRequirements}
                            onChange={handleInputChange}
                            placeholder="Dietary requirements, accessibility needs, etc."
                        />
                    </div>

                    <button type="submit" className="confirm-booking-btn">
                        Add to Cart & Continue <FaArrowRight />
                    </button>
                </form>
            </div>
        </div>
    );
};

export default BookingPage;
